import Component from '../core/Component'
import {EMITS as SLIDER_EMITS} from './Slider'

export const STATES = {
    IS_NONZERO_INDEX: 'is-nonzero-index'
}

export default class HomepageLocations extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            slider: null
        }
    }

    prepare() {
        this.slider = Component.getFromElement(this.ref.slider)

        this.slider.on(SLIDER_EMITS.SELECTED, this.handleSliderSelected)
    }

    handleSliderSelected = data => {
        const index = data.index

        if (index > 0) {
            this.element.classList.add(STATES.IS_NONZERO_INDEX)
        } else {
            this.element.classList.remove(STATES.IS_NONZERO_INDEX)
        }
    }
}